export const TRANSACTION_ROW_HEIGHT_PX = 41;
